'use strict';

const inputPatternUtils = require('../modules/utils/input_pattern_utils');
const fieldUtils = require('../modules/utils/field.utils');
const creditCardTypes = require('../modules/data/credit_card_types');
const creditCardUtils = require('../modules/utils/credit_card.utils');

Odigeo.defineWidget(
    'post_booking_bin_detection',
    Odigeo.Widget.extend({
        xhr: null,

        modelClass: Odigeo.Model.extend({
            dataURL: 'getcreditcardbindetailsCardBin',
            defaults: {
                creditCardBinCache: [],
                creditCardNumber: '',
                creditCardType: '',
                creditCardTypeCode: '',
                creditCardBin: '',
            },

            init: function() {
                Odigeo._.extend(this.widget.options, {hiddenCards: ['VB', 'E1', 'EA']});
                this.widget.options = Odigeo.parseOptions(this.widget.options);

                this.on('change:creditCardNumber', this.onCreditCardNumberChange);
                this.on('change:creditCardBin', this.onCreditCardBinChange);
            },

            getCreditCardTypeCode: function(creditCardBinDetails) {
                return creditCardBinDetails.creditCardTypeDTO.creditCardCode;
            },

            onCreditCardNumberChange: function() {
                var creditCardNumber = this.get('creditCardNumber');
                var creditCardBin = creditCardNumber.substring(0, 8);

                if (creditCardUtils.isValidCreditCard(creditCardNumber)) {
                    if (creditCardBin !== this.get('creditCardBin')) {
                        this.set('creditCardBin', creditCardBin);
                    }
                } else {
                    this.set({
                        creditCardType: '',
                        creditCardTypeCode: '',
                        creditCardBin: '',
                    });
                }
            },

            onCreditCardBinChange: function() {
                var creditCardBin = this.get('creditCardBin');
                var creditCardBinCache = this.get('creditCardBinCache');
                var binDetailsCached = Odigeo._.find(creditCardBinCache, {creditCardBin: creditCardBin});

                if (this.xhr) {
                    this.xhr.abort();
                }

                if (Odigeo._.isObject(binDetailsCached)) {
                    this.set({
                        creditCardTypeCode: this.getCreditCardTypeCode(binDetailsCached),
                    });
                } else if (creditCardBin) {
                    this.xhr = this.fetch(this.getRequest({creditCardBin: creditCardBin}));
                }
            },

            getRequest: function(data) {
                return {
                    type: 'POST',
                    data: JSON.stringify(data),
                    timeout: 11000,
                    contentType: 'application/json',
                    dataType: 'json',
                    cache: false,
                    success: Odigeo._.bind(this.requestSuccessHandler, this),
                    error: Odigeo._.bind(this.requestErrorHandler, this),
                };
            },

            requestSuccessHandler: function(model, data) {
                if (data.error) {
                    this.trigger('unknownCardType', data.error);
                } else {
                    this.get('creditCardBinCache').push(data);
                    this.set({
                        creditCardBinDetails: data,
                        creditCardTypeCode: this.getCreditCardTypeCode(data),
                    });
                }
                this.xhr = null;
            },

            requestErrorHandler: function() {
                this.xhr = null;
                this.trigger('unknownCardType', 'ERROR500_ONEFRONT_NOT_RESPONSE');
            },

            url: function() {
                return Odigeo.Settings.getProperty('serviceCollectionMethodFormatter')(this.dataURL);
            },
        }),

        viewClass: Odigeo.View.extend({
            selectors: {
                binDetectionContainer: '.bin_detection_container',
                ccFeePrice: '.cc_fee_price',
                ccnumber: 'input[name="ccnumber"]',
                binDetectionCcFeesListTemplate: '.bin_detection_cc_fees_list_template',
                creditCardFeesBinDetection: '#creditCardFeesBinDetection',
                binDetectionCcFeesList: '.bin_detection_cc_fees_list',
                ccCardType: 'select[data-name="cardTypeSelector"]',
                ccTypeIcon: '.cc_type_icon',
                ccNotDetected: '.cc_not_detected',
                ccDetectedSelectedOk: '.cc_detected_selected_ok',
                ccNumberNotAvailable: '.cc_number_not_available',
                openCcList: '.open_cc_list',
                clearInput: '.clear_input',
            },

            init: function() {
                this.listenTo(this.model, 'change:creditCardTypeCode', this.onCreditCardTypeCodeChange);

                this.$cachedSelectors.clearInput.on(Odigeo.Events.tap, Odigeo._.bind(this.widget.creditCardNumberChanged, this.widget, false));
                this.$cachedSelectors.ccnumber.on(Odigeo.Events.change, Odigeo._.bind(this.widget.creditCardNumberChanged, this.widget, false));
                this.$cachedSelectors.ccnumber.on(Odigeo.Events.input, Odigeo._.bind(this.widget.creditCardNumberChanged, this.widget, false));
            },

            setCreditCardTypeIcon: function(creditCardType) {
                this.$cachedSelectors.ccTypeIcon.attr('data-card', creditCardType);
            },

            setCreditCardFormat: function(creditCardType) {
                if (creditCardType) {
                    inputPatternUtils.setSelectedCreditCard(creditCardType);
                    this.$cachedSelectors.ccnumber.trigger(Odigeo.Events.input).trigger(Odigeo.Events.keydown);
                }
            },

            onCreditCardTypeCodeChange: function() {
                var code = this.model.get('creditCardTypeCode');
                var name = creditCardTypes[code] ? creditCardTypes[code].name : code;

                this.setCreditCardTypeIcon(code);
                this.setCreditCardFormat(code);

                Odigeo.trigger(this.widget.id + ':creditCardTypeCodeChanged', code, name);
            },
        }),

        creditCardNumberChanged: Odigeo._.debounce(function(isPaste) {
            var creditCardNumber = this.view.$cachedSelectors.ccnumber.val();

            this.model.set({
                isPaste: isPaste,
                creditCardNumber: fieldUtils.trimCreditCardNumber(creditCardNumber),
            });
        }, 300),
    })
);
